import React from 'react'
import DigitalFirst from './DigitalFirst'
import DigitalSecond from './DigitalSecond'
import DigitalThird from './DigitalThird'
import ContactSection from './ContactSection'
// import ContactForm from './ContactForm'

const DigitalMarketingPage = () => {
  return (
    <div>
      <DigitalFirst/>
      <DigitalSecond/>
      <DigitalThird/>
      <ContactSection />
      {/* <ContactForm /> */}
    </div>
  )
}

export default DigitalMarketingPage

